import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import {
  cancelProcessTransactionStartModalDialog,
  closeProcessTransactionStartModalDialog,
  resetProcessTransactionStartModalDialog,
  submitProcessTransactionStartModalDialog,
  validateProcessTransactionStartModalDialog,
} from '../../actions/start_process_transaction'
import ProcessTransactionStartForm from './process_transaction_start_form'

class ProcessTransactionStartModalDialog extends PureComponent {
  handleCloseModal() {
    const { closeProcessTransactionStartModalDialog } = this.props
    closeProcessTransactionStartModalDialog()
  }

  render() {
    const { isModalDialogOpen, cancelProcessTransactionStartModalDialog, isSubmitted, txId } = this.props
    const onHide = isSubmitted ? () => this.handleCloseModal() : cancelProcessTransactionStartModalDialog

    return (
      <Modal show={isModalDialogOpen} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Process Transaction</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ProcessTransactionStartForm txId={txId} />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  isSubmitted: state.processTransactionStartModalDialog.isSubmitted,
  isValidated: state.processTransactionStartModalDialog.isValidated,
  newData: state.processTransactionStartModalDialog.newData,
  isModalDialogOpen: state.processTransactionStartModalDialog.isModalDialogOpen,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeProcessTransactionStartModalDialog,
      cancelProcessTransactionStartModalDialog,
      submitProcessTransactionStartModalDialog,
      validateProcessTransactionStartModalDialog,
      resetProcessTransactionStartModalDialog,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProcessTransactionStartModalDialog))
